// 브라우저 번역 안전망 (CLAUDE.md Phase 8)
// Chrome·Edge·Safari 등의 페이지 번역은 텍스트 노드를 <font> 로 바꿔 끼우거나 다른 요소 안으로 옮긴다.
// React 는 자기가 만든 노드를 기억했다가 removeChild/insertBefore 를 부르는데, 그 노드가 더 이상 그 부모의 자식이 아니면
// DOM 이 NotFoundError 를 던지고 React 루트가 통째로 언마운트되어 흰 화면이 된다 (facebook/react#11538).
// 그런 경우에만 보정하고 정상적인 호출은 원래 메서드로 그대로 넘긴다. 콘솔 로그는 남기지 않는다(프로젝트 규칙)
const INSTALLED = Symbol.for('webPortfolio.translationSafeDom');

export function installTranslationSafeDom() {
  if (typeof Node !== 'function' || !Node.prototype || Node.prototype[INSTALLED]) return;

  const originalRemoveChild = Node.prototype.removeChild;
  const originalInsertBefore = Node.prototype.insertBefore;

  Node.prototype.removeChild = function removeChild(child) {
    if (child && child.parentNode !== this) {
      // 번역기가 노드를 다른 요소(<font> 등) 안으로 옮겼으면 실제 부모에서 뗀다. 이미 문서에서 빠졌으면 할 일이 없다
      if (child.parentNode && this.contains(child)) {
        return originalRemoveChild.call(child.parentNode, child);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      // 기준 노드가 다른 요소 안으로 옮겨졌으면 이 부모의 직계 자식인 조상 앞에 넣는다. 문서에서 빠졌으면 끝에 붙인다
      let anchor = referenceNode.parentNode ? referenceNode : null;
      while (anchor && anchor.parentNode !== this) anchor = anchor.parentNode;
      return originalInsertBefore.call(this, newNode, anchor);
    }
    return originalInsertBefore.apply(this, arguments);
  };

  Node.prototype[INSTALLED] = true;
}
